import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {Redirect, withRouter} from 'react-router-dom';

class RedirectWithParams extends PureComponent {
    static propTypes = {
        location: PropTypes.object,
        to: PropTypes.string
    };

    static defaultProps = {
        location: {}
    };

    render() {
        const location = this.props.location || {};
        const to = this.props.to || '/';
        const search = location.search || '';

        //append url params as long as they aren't already included
        //TODO enhance this to convert and combine query params
        let path = to;
        if (path.indexOf('?') === -1) {
            path += search;
        }

        return <Redirect to={path} />;
    }
}

export default withRouter(RedirectWithParams);
